import * as React from 'react';
import parseHTML from 'html-react-parser';

export default function RenderHTML({ children }){
  return <div className="container">{parseHTML(children)}</div>;
}
